/**
 * Removes the leading trap-number prefix from a greyhound runner name so the
 * trap number is shown only inside the colour badge.
 * Handles the two prefixed formats the BFF recognises
 * (see `extractTrapNumberFromRunnerName`): `"1. Reckless Sparks"` and
 * `"Trap 5: Reckless Sparks"` → `"Reckless Sparks"`. Names without a
 * prefix (e.g. `"VACANT T6"`, plain Irish names) are returned unchanged.
 */
export function stripGreyhoundTrapPrefix(name: string): string {
  return name.replace(/^(?:Trap \d+:|\d+\.)\s*/, "");
}
